import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "contexts/AuthContext";
import { useEffect, useState } from "react";
import { getMe } from "api/coreApi";

const RequireAuth = ({ children }) => {
  const { status } = useAuth();
  const location = useLocation();
  const [bootstrapped, setBootstrapped] = useState(false);

  useEffect(() => {
    const bootstrap = async () => {
      try {
        // this triggers refresh if needed
        await getMe();
      } catch {
        // ignore
      } finally {
        setBootstrapped(true);
      }
    };

    bootstrap();
  }, []);

  if (!bootstrapped || status === "loading") {
    return null; // or spinner
  }

  if (status === "unauthenticated") {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
};

export default RequireAuth;
